import { useAppSelector } from '../../app/hooks';
import { selectUser } from './Auth0.slice';
import { useMemo } from 'react';
import { UserWithCustomClaims } from './user.model';

export const useUserAuthenticated = (): UserWithCustomClaims | undefined => {
    const user = useAppSelector(selectUser);
    return useMemo(() => user, [user]);
};
